"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14097],{

/***/ 6595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30553);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80797);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59000);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36456);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96149);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86700);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94455);
/* harmony import */ var _hooks_useAddress__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59361);
/* harmony import */ var _AddressForm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12907);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66026);
/* provided dependency */ var process = __webpack_require__(34155);













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        root: {
            margin: theme.spacing(0, 0, 2)
        },
        form: {},
        formContent: _defineProperty({
            margin: theme.spacing(0, 0, 2)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(0, 2)
        }),
        label: {},
        labelCheckbox: _defineProperty({
            display: 'flex',
            cursor: 'pointer',
            marginTop: 10,
            marginBottom: 20
        }, theme.breakpoints.up('md'), {
            alignItems: 'center'
        }),
        checkboxInput: {
            border: '1px solid #efefef',
            background: '#fff',
            marginBottom: 0,
            marginRight: 5,
            lineHeight: 'normal',
            width: 15,
            height: 15
        },
        labelCheckboxSpan: {
            color: theme.typography.body1.color,
            fontSize: '11px',
            lineHeight: '17px',
            display: 'inline-block',
            cursor: 'pointer',
            fontWeight: 'normal',
            marginBottom: '0px'
        },
        couponCodeTxt: {
            marginTop: '8px',
            marginBottom: '10px',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: '12px'
        },
        messageContainer: {
            marginTop: '8px',
            marginBottom: '10px',
            fontSize: '12px'
        },
        errorMessage: {
            color: 'red'
        },
        backLink: {
            color: theme.extraColors.greyText,
            marginBottom: theme.spacing(2),
            display: 'inline-flex'
        },
        backArrow: {
            width: 20,
            marginRight: theme.spacing(1)
        },
        formSubmit: {
            textAlign: 'center',
            '&> .MuiButton-root': _defineProperty({
                width: '100%'
            }, theme.breakpoints.up('sm'), {
                width: '50%'
            })
        },
        createAccount: {
            marginTop: theme.spacing(2),
            textAlign: 'center',
            textDecoration: 'underline',
            cursor: 'pointer',
            '&> a': {
                color: 'inherit'
            }
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        shippingAddressNoBottomMargin: {
            marginBottom: 0
        },
        sameAddressCheckbox: {
            marginBottom: theme.spacing(2)
        }
    });
});
var InformationForm = function(props) {
    var ref18, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var classes = useStyles(props);
    var TextField = props.textFieldComponent, onSubmit = props.onSubmit, text = props.text, accountText = props.accountText, t = props.t, user = props.user, switchForm = props.switchForm, infoMessage = props.infoMessage, error = props.error, cart = props.cart, hasError = props.hasError, errorPhone = props.errorPhone, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, _prefill = props.prefill, prefill = _prefill === void 0 ? false : _prefill, generalConfigData = props.generalConfigData, information = props.information;
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().trackEvent;
    var ref14 = (0,_hooks_useAddress__WEBPACK_IMPORTED_MODULE_7__/* .useAddress */ .S)('shipping'), shippingAddress = ref14.address, resetInputShippingAddress = ref14.resetInputAddress;
    var ref15 = (0,_hooks_useAddress__WEBPACK_IMPORTED_MODULE_7__/* .useAddress */ .S)('billing'), billingAddress = ref15.address, resetInputBillingAdress = ref15.resetInputAddress;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), billingAndShippingAddressesAreTheSame = ref16[0], setBillingAndShippingAddressesAreTheSame = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        firstName: {
            type: 'text',
            value: (information === null || information === void 0 ? void 0 : information.firstName) || (user === null || user === void 0 ? void 0 : (ref18 = user.user) === null || ref18 === void 0 ? void 0 : ref18.firstName) || ''
        },
        lastName: {
            type: 'text',
            value: (information === null || information === void 0 ? void 0 : information.lastName) || (user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.lastName) || ''
        },
        email: {
            type: 'email',
            value:  true && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.email) || (information === null || information === void 0 ? void 0 : information.email) || (user === null || user === void 0 ? void 0 : (ref2 = user.user) === null || ref2 === void 0 ? void 0 : ref2.email) || ''
        },
        phone: {
            type: 'tel',
            value: (information === null || information === void 0 ? void 0 : information.phoneNumber) || (user === null || user === void 0 ? void 0 : (ref3 = user.user) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber) || ''
        },
        vatNumber: {
            type: 'text',
            value: (information === null || information === void 0 ? void 0 : information.vatNumber) || (user === null || user === void 0 ? void 0 : (ref4 = user.user) === null || ref4 === void 0 ? void 0 : ref4.vatNumber) || ''
        },
        company: {
            // Fallback sur la raison sociale du compte (shopName B2B SSO, ou company de
            // l'adresse) si le panier ne la porte pas encore.
            type: 'text',
            value: (information === null || information === void 0 ? void 0 : information.company) || (user === null || user === void 0 ? void 0 : (ref5 = user.user) === null || ref5 === void 0 ? void 0 : ref5.shopName) || (user === null || user === void 0 ? void 0 : (ref6 = user.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.address) === null || ref7 === void 0 ? void 0 : ref7.company) || ''
        }
    }), userInfo = ref17[0], setUserInfo = ref17[1];
    var disableContinueButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var userInfosFormValid = userInfo.firstName.value && userInfo.lastName.value && userInfo.email.value && userInfo.phone.value;
        var B2BFormValid = userInfo.company.value && userInfo.vatNumber.value;
        return !userInfosFormValid || !shippingAddress.isValid || _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP && !B2BFormValid || !billingAndShippingAddressesAreTheSame && !billingAddress.isValid;
    }, [
        userInfo,
        shippingAddress.isValid,
        billingAndShippingAddressesAreTheSame,
        billingAddress.isValid,
        _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP, 
    ]);
    var bottomText = accountText === null || accountText === void 0 ? void 0 : accountText.information_bottom_text;
    var usedFields = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (_utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP) {
            return Object.keys(userInfo);
        }
        // Hors B2B : pas de vatNumber, et company seulement si activé (raison sociale
        // livraison B2B Atlantic/Thermor), positionné juste après le nom.
        var fields = Object.keys(userInfo).filter(function(field) {
            return field !== 'vatNumber' && field !== 'company';
        });
        if (_utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isShippingCompanyEnabled */ .Aq) {
            fields.splice(fields.indexOf('lastName') + 1, 0, 'company');
        }
        return fields;
    }, [
        userInfo,
        _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP
    ]);
    var handleInputChange = function(field) {
        return function(value) {
            setUserInfo(function(prev) {
                return _objectSpread({}, prev, _defineProperty({}, field, _objectSpread({}, prev[field], {
                    value: value
                })));
            });
        };
    };
    var handleCheckboxChange = function(event) {
        setBillingAndShippingAddressesAreTheSame(event.target.checked);
    };
    var onSubmitForm = function(e) {
        e.preventDefault();
        localStorage.setItem('email', userInfo.email.value);
        var userProps = {
            firstName: userInfo.firstName.value.trim(),
            lastName: userInfo.lastName.value.trim(),
            phoneNumber: userInfo.phone.value,
            company: userInfo.company.value.trim()
        };
        var billingAddressPayload = billingAndShippingAddressesAreTheSame ? shippingAddress : billingAddress;
        onSubmit(_objectSpread({}, userProps, shippingAddress.payload), _objectSpread({}, userProps, {
            vatNumber: userInfo.vatNumber.value.trim()
        }, billingAddressPayload.payload));
        resetInputShippingAddress();
        resetInputBillingAdress();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var isShippingSameAsBilling = (ref = cart.item) === null || ref === void 0 ? void 0 : ref.isShippingSameAsBilling;
        if (isShippingSameAsBilling !== undefined) {
            setBillingAndShippingAddressesAreTheSame(isShippingSameAsBilling);
        }
    }, [
        (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : ref8.isShippingSameAsBilling
    ]);
    // Pré-remplit les champs connus depuis le compte utilisateur s'il se charge
    // après le montage, uniquement pour les champs encore vides (sans écraser une
    // saisie en cours).
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref26, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
        var accountValues = {
            firstName: user === null || user === void 0 ? void 0 : (ref26 = user.user) === null || ref26 === void 0 ? void 0 : ref26.firstName,
            lastName: user === null || user === void 0 ? void 0 : (ref19 = user.user) === null || ref19 === void 0 ? void 0 : ref19.lastName,
            email: user === null || user === void 0 ? void 0 : (ref20 = user.user) === null || ref20 === void 0 ? void 0 : ref20.email,
            phone: user === null || user === void 0 ? void 0 : (ref21 = user.user) === null || ref21 === void 0 ? void 0 : ref21.phoneNumber,
            vatNumber: user === null || user === void 0 ? void 0 : (ref22 = user.user) === null || ref22 === void 0 ? void 0 : ref22.vatNumber,
            company: (user === null || user === void 0 ? void 0 : (ref23 = user.user) === null || ref23 === void 0 ? void 0 : ref23.shopName) || (user === null || user === void 0 ? void 0 : (ref24 = user.user) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.address) === null || ref25 === void 0 ? void 0 : ref25.company)
        };
        setUserInfo(function(prev) {
            var changed = false;
            var next = _objectSpread({}, prev);
            Object.entries(accountValues).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                var ref;
                if (value && !((ref = prev[key]) === null || ref === void 0 ? void 0 : ref.value)) {
                    next[key] = _objectSpread({}, prev[key], {
                        value: value
                    });
                    changed = true;
                }
            });
            return changed ? next : prev;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.user
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        in: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.root),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.form),
                onSubmit: onSubmitForm,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.formContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                container: true,
                                spacing: 2,
                                children: usedFields.map(function(key) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: key === 'company' ? 12 : 6,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextField, {
                                            label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text[key], t("texts:account:".concat(key.toLowerCase()))),
                                            name: key,
                                            placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text[key], t("texts:account:".concat(key.toLowerCase()))),
                                            value: userInfo[key].value,
                                            onChange: handleInputChange(key),
                                            required: key !== 'company',
                                            phoneInputInfosIcon: key === 'tel' ? {
                                                tooltipTitle: generalConfigData === null || generalConfigData === void 0 ? void 0 : generalConfigData.phone_input_infos
                                            } : undefined
                                        })
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressForm__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_defineProperty({}, classes.shippingAddressNoBottomMargin, _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP)),
                                prefill: prefill,
                                addressType: "shipping",
                                defaultAddress: user === null || user === void 0 ? void 0 : (ref9 = user.user) === null || ref9 === void 0 ? void 0 : ref9.address,
                                hideAdditionalAddress: (ref10 = props.prismicFunnelData) === null || ref10 === void 0 ? void 0 : ref10.hide_additional_address
                            }),
                            (_utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .isB2B */ .tP || process.env.IS_SHIPPING_ADDRESS_SEPARATE === 'true' || (generalConfigData === null || generalConfigData === void 0 ? void 0 : generalConfigData.is_shipping_address_separate)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                className: classes.sameAddressCheckbox,
                                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    checked: billingAndShippingAddressesAreTheSame,
                                    onChange: handleCheckboxChange
                                }),
                                label: t('texts:general:search_address:same_address')
                            }),
                            !billingAndShippingAddressesAreTheSame && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddressForm__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                prefill: prefill,
                                addressType: "billing",
                                defaultAddress: user === null || user === void 0 ? void 0 : (ref11 = user.user) === null || ref11 === void 0 ? void 0 : ref11.address,
                                hideAdditionalAddress: (ref12 = props.prismicFunnelData) === null || ref12 === void 0 ? void 0 : ref12.hide_additional_address
                            }),
                            infoMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.messageContainer),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: infoMessage
                                })
                            }),
                            error && error.message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.messageContainer, classes.errorMessage),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: error.message
                                })
                            }),
                            hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: 'body2',
                                color: 'error',
                                align: 'center',
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: text === null || text === void 0 ? void 0 : text.error_happend,
                                    defaultText: t('texts:account:error_happend')
                                })
                            }),
                            errorPhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: 'body2',
                                color: 'error',
                                align: 'center',
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: text === null || text === void 0 ? void 0 : text.error_phone,
                                    defaultText: t('texts:account:error_phone')
                                })
                            })
                        ]
                    }),
                    (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* .isPrismicText */ .LT)(bottomText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        variant: 'body2',
                        component: 'div',
                        className: 'account__bottom-text',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                            data: bottomText
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.formSubmit,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: "large",
                            type: "submit",
                            "data-testid": "nextInformation",
                            color: "secondary",
                            onClick: function() {
                                return trackEvent({
                                    category: 'User Information',
                                    action: "Valid Information form"
                                });
                            },
                            variant: "contained",
                            className: "offer-subscribe",
                            disabled: cart.loading || userInfo.firstName.value === '' || userInfo.lastName.value === '' || userInfo.email.value === '' || disableContinueButton || disabled,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: cart.loading ? classes.hide : classes.show,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: text === null || text === void 0 ? void 0 : text.next1,
                                        defaultText: t('texts:account:next')
                                    })
                                }),
                                cart.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                            ]
                        })
                    }),
                    !(user === null || user === void 0 ? void 0 : (ref13 = user.user) === null || ref13 === void 0 ? void 0 : ref13.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.createAccount,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            variant: 'body2',
                            color: 'textSecondary',
                            onClick: function() {
                                return switchForm(1);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : text.create_account_link,
                                defaultText: t('texts:account:login_link')
                            })
                        })
                    })
                ]
            })
        })
    }));
};
InformationForm.defaultProps = {
    textFieldComponent: _TextField_TextField__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        user: state.user
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(mapStateToProps)(InformationForm));


/***/ }),

/***/ 45733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useCartHasStockError; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36456);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16502);


function useCartHasStockError() {
    var ref, ref1, ref2;
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.cart;
    });
    var stock = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.stock;
    });
    if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length)) return false;
    if (!(stock === null || stock === void 0 ? void 0 : (ref2 = stock.stockBasket) === null || ref2 === void 0 ? void 0 : ref2.length)) return false;
    return cart.item.items.some(function(product) {
        var availability = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .checkStockQuantityByItemType */ .qe)(stock, product.product.variants[0], product.type, 'basket');
        return product.quantity > (availability !== null && availability !== void 0 ? availability : 0);
    });
}


/***/ }),

/***/ 93397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useVirginSSOAuth; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66026);
/* harmony import */ var _redux_services_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18611);
/* provided dependency */ var process = __webpack_require__(34155);
// useVirginSSOAuth.ts



function useVirginSSOAuth(router) {
    var withRedirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isCheckingAuth = ref[0], setIsCheckingAuth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        //  Ne rien faire tant que le routeur n'est pas prêt
        if (!router.isReady) return;
        var query = router.query;
        var accessToken = query === null || query === void 0 ? void 0 : query['access_token'];
        var tokenExpireAt = query === null || query === void 0 ? void 0 : query['token_expires_at'];
        var loginMethod = query === null || query === void 0 ? void 0 : query['login_method'];
        var ssoState = query === null || query === void 0 ? void 0 : query['state'];
        if (accessToken) {
            saveTokensToLocalStorage({
                accessToken: accessToken,
                tokenExpireAt: tokenExpireAt,
                loginMethod: loginMethod,
                ssoState: ssoState
            });
            // Fetch and store refresh token
            (0,_redux_services_user__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentRefreshToken */ .xt)().then(function(data) {
                if (data === null || data === void 0 ? void 0 : data.refresh_token) {
                    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.REFRESH_TOKEN */ .dA.REFRESH_TOKEN, data.refresh_token);
                }
            }).catch(function(error) {
                console.error('Failed to get refresh token:', error);
            });
            // Clean up query parameters from URL
            var cleanUrl = window.location.pathname + window.location.hash;
            router.replace(cleanUrl, undefined, {
                shallow: true
            });
        } else {
            if (!withRedirection) return;
            // Vérifier si on a déjà des tokens en localStorage
            try {
                var storedToken = localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN);
                if (!storedToken) {
                    router.push('/register');
                }
            } catch (error) {
                router.push('/register');
            }
        }
        setIsCheckingAuth(false);
    }, [
        router.isReady
    ]) // Uniquement réagir quand router.isReady change
    ;
    return {
        isCheckingAuth: isCheckingAuth
    };
}
function saveTokensToLocalStorage(param) {
    var accessToken = param.accessToken, tokenExpireAt = param.tokenExpireAt, loginMethod = param.loginMethod, ssoState = param.ssoState;
    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN, accessToken);
    if (tokenExpireAt) {
        localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.TOKEN_EXPIRE_AT */ .dA.TOKEN_EXPIRE_AT, tokenExpireAt);
    }
    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE, process.env.SSO_TYPE || '');
    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.LOGIN_METHOD */ .dA.LOGIN_METHOD, loginMethod || '');
    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.SSO_STATE */ .dA.SSO_STATE, ssoState || '');
    localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEYS.USER_TYPE */ .dA.USER_TYPE, 'SSO');
}


/***/ }),

/***/ 89910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jC": function() { return /* binding */ billingAddressForThermorCheckoutPut; },
/* harmony export */   "wR": function() { return /* binding */ getCartSecondHandItems; },
/* harmony export */   "Vk": function() { return /* binding */ getCurrentSkuProductInCart; },
/* harmony export */   "_y": function() { return /* binding */ getCurrentProductTypeInCart; },
/* harmony export */   "Lj": function() { return /* binding */ getSecondHandProductInformation; },
/* harmony export */   "Ci": function() { return /* binding */ isOnlySecondHandInCart; }
/* harmony export */ });
/* unused harmony exports getCartSecondHandItem, getProductTypeInCart, getProductsTypeInCart */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66026);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cartHasPersistedBilling = function(b) {
    var ref, ref1;
    return !!(b && (((ref = b.street) === null || ref === void 0 ? void 0 : ref.trim()) || ((ref1 = b.postcode) === null || ref1 === void 0 ? void 0 : ref1.trim())));
};
/**
 * Si Thermor SSO et que le panier a déjà une facturation, renvoie celle du panier ;
 * sinon la valeur proposée (ex. formulaire ou profil).
 */ var billingAddressForThermorCheckoutPut = function(proposed, cartItem) {
    if (!_constants__WEBPACK_IMPORTED_MODULE_0__/* .isThermorSSO */ .y || !cartItem) return proposed;
    var existing = cartItem.billingAddress;
    if (cartHasPersistedBilling(existing)) return _objectSpread({}, existing);
    return proposed;
};
// format second hand informations from cart
var getCartSecondHandItem = function(item) {
    var units = item.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid
        };
    });
    return {
        sku: item.product.variants[0].sku,
        units: units
    };
};
// get all informations about 2nde hand products in cart according cartSecondHandItems typing
var getCartSecondHandItems = function(cart) {
    var ref, ref2;
    return (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref2 = ref.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
        return getCartSecondHandItem(item);
    })) || [];
};
// get second hand informations products in cart for according current sku
var getCurrentSkuProductInCart = function(secondHandProductsInCart, currentSku) {
    return secondHandProductsInCart === null || secondHandProductsInCart === void 0 ? void 0 : secondHandProductsInCart.filter(function(secondHandProduct) {
        return secondHandProduct.sku === currentSku;
    });
};
// get type of products in cart (second hand or rental)
var getProductTypeInCart = function(item) {
    var ref;
    return {
        code: item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.code,
        type: item === null || item === void 0 ? void 0 : item.type
    };
};
var getProductsTypeInCart = function(cart) {
    var ref, ref3;
    return cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref3 = ref.items) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
        return getProductTypeInCart(item);
    });
};
// get type of current product in cart (case of rent and 2nde hand)
var getCurrentProductTypeInCart = function(currentItem, cart) {
    var productsInCartWithType = getProductsTypeInCart(cart);
    var currentItemCode = currentItem.code;
    var currentProductInCart = productsInCartWithType === null || productsInCartWithType === void 0 ? void 0 : productsInCartWithType.find(function(product) {
        return product.code === currentItemCode;
    });
    if (!currentProductInCart) return null;
    return currentProductInCart.type;
};
// second hand informations to display them on confirmation's page
var getSecondHandProductInformation = function(secondHandProduct) {
    var ref, ref4, ref5, ref6;
    var units = secondHandProduct.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid,
            productPrice: unit.price
        };
    });
    return {
        productName: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref = secondHandProduct.product) === null || ref === void 0 ? void 0 : ref.name,
        productImage: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref4 = secondHandProduct.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.images) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.cachedPath,
        units: units,
        taxonPromotionPercent: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : secondHandProduct.taxonPromotionPercent
    };
};
// there is only second hand in cart
var isOnlySecondHandInCart = function(cart) {
    var ref;
    return !((ref = getProductsTypeInCart(cart)) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_ITEM_TYPE.RENTAL */ ._$.RENTAL;
    }));
};


/***/ })

}]);